import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()( ({
    profileTab: {
      position: 'relative',
      '& .MuiTabScrollButton-root.Mui-disabled': {
        opacity: '0.6',
      },
    },
  }));